@if (isReadonly()) {
  @if (currentClientId && (selectedClient$ | async); as selectedClient) {
    <!-- Header -->
    <div class="surface-0 border-round shadow-3 md:my-2 md:flex" data-testid="selected-client-card">
      <!-- Left Side -->
      <div class="md:w-9 flex align-items-center justify-content-between px-3 py-2" (click)="navigateToClientProfile(selectedClient)" data-testid="client-profile-link" aria-label="Client profile">
        <div class="flex align-items-center cursor-pointer">
          <div class="hidden md:block">
            @if (selectedClient.clt_image) {
              <p-avatar image="{{selectedClient.clt_image}}" shape="circle" aria-label="client-avatar" data-testid="client-avatar" />
            }
            @if (!selectedClient.clt_image) {
              @if (!selectedClient.clt_image) {
                <p-avatar [label]="client2LetterName(selectedClient.clt_full_name) | titlecase | shortName"
                  shape="circle" aria-label="client-initials" data-testid="client-initials" />
              }
            }
          </div>
          <div class="md:hidden">
            @if (selectedClient.clt_image) {
              <p-avatar image="{{selectedClient.clt_image}}" shape="circle" aria-label="client-avatar-mobile" data-testid="client-avatar-mobile" />
            }
            @if (!selectedClient.clt_image) {
              @if (!selectedClient.clt_image) {
                <p-avatar [label]="client2LetterName(selectedClient.clt_full_name) | titlecase | shortName"
                  shape="circle" aria-label="client-initials-mobile" data-testid="client-initials-mobile" />
              }
            }
          </div>
          <h3 class="mb-0 text-primary text-sm md:text-base mx-2" data-testid="client-name">{{selectedClient.clt_full_name}}</h3>
          <p class="mb-0 text-xxs md:text-xs text-600" data-testid="client-id">- {{selectedClient.clt_id}}</p>
        </div>
        <div class="flex align-items-center">
          <!-- <div class="relative mr-2 w-6rem h-2rem overflow-hidden flex align-items-center"><img
          src="/assets/img/icons/opportunity-stage-bg.svg" class="absolute w-6rem h-2rem"><span
        class="relative z1 text-xs text-primary font-bold ml-2 w-10 block overflow-hidden text-overflow-ellipsis white-space-nowrap text-ellipsis block line-height-4">Negotiate</span>
      </div> -->
      <div [innerHTML]="clientStatus(selectedClient)" data-testid="client-status"></div>
    </div>
  </div>
  <!-- Left Side -->
  <!-- Right Side -->
  <div class="md:w-3 bg-blue-50 px-2 flex md:justify-content-center align-items-center text-900" data-testid="client-contact-info">
    <ul class="list-none m-0 p-0 text-xs">
      <li class="my-2 flex align-items-center" data-testid="client-phone">
        <i class="fa fa-phone text-600 mr-2"></i>
        <strong>{{selectedClient.clt_mobile_country_code}}
        {{selectedClient.clt_mobile_no}}</strong>
      </li>
      <!-- <li class="my-2 flex align-items-center">
      <i class=" fa fa-envelope font-light text-600 mr-2"></i>
      <a href="mailto:andrea@andreasolan.com" class="text-primary">andrea@andreasolan.com</a>
    </li> -->
  </ul>
</div>
<!-- Right Side -->
</div>
<!-- Header -->
}
@if ((clientIds$ | async); as ids) {
  @if (ids && ids.length > 0) {
    <div
      class="flex align-items-center relative" data-testid="multiple-clients-container">
      <div class="w-full md:flex align-items-center justify-content-between">
        <div class="mt-1 flex flex-wrap align-items-center">
          @for (member of (selectedClients$ | async); track member; let i = $index) {
            @if (i<3) {
              <p-chip styleClass="mr-2 bg-primary text-sm" [label]="client2LetterName(member.full_name)"
                image="{{member.image}}" [removable]="false" [attr.data-index]="i"
                [attr.data-testid]="'client-chip-' + i" [attr.aria-label]="'client-' + member.full_name" />
            }
          }
        </div>
        @if (ids.length > 3) {
          <div
            class="mt-2 md:mt-0 text-primary font-bold text-sm cursor-pointer md:text-right text-left flex align-items-center"
            (click)="showAllMembers = true" data-testid="show-more-clients" aria-label="Show more clients">{{ 'Shared.SEARCH.MINI-SEARCH.N-MORE' | translate: paramNMore }}
            <i class="fa fa-chevron-down ml-2"></i>
          </div>
        }
      </div>
    </div>
  }
}
}

@if (!isReadonly()) {
  <div class="flex align-items-center" data-testid="client-search-container">
    <div class="relative w-full p-inputgroup">
      @if (!currentClientId) {
        <span class="p-inputgroup-addon h-full surface-0-alpha-10 border-none absolute left-0 top-0 flex align-items-center justify-content-center pl-3 z-2">
          <i class="fa fa-search"></i>
        </span>
        <p-autoComplete #ac [(ngModel)]="selectedClient" [showEmptyMessage]="true"
          [disabled]="isDisabled()"
          [appendTo]="'body'"
          [suggestions]="members$ | async" styleClass="w-full h-full border-round"
          [inputStyleClass]="'outline-none border-round text-sm text-600 pr-3 pl-6'"
          [panelStyleClass]="'absolute left-0 origin-top w-full surface-0 border-1 border-300 shadow-2 z-5 justify-content-between'"
          (completeMethod)="searchClients($event)" field="clt_full_name" showClear="true"
          placeholder="{{'Shared.SEARCH.MINI-SEARCH.PLACEHOLDER-SEARCH-CLIENT' | translate}}"
          (onSelect)="setClient($event, ac)" aria-label="Search for client" data-testid="client-search-input">
          <ng-template let-client pTemplate="item">
            <div class="flex align-items-center justify-content-between px-3 py-2 hover:surface-50" data-testid="client-search-item">
              <!-- Left Section: Avatar + Client Info -->
              <div class="flex align-items-center flex-1 min-w-0">
                @if (client.clt_image) {
                  <p-avatar image="{{client.clt_image}}" shape="circle" aria-label="client-search-avatar" data-testid="client-search-avatar" />
                }
                @if (!client.clt_image) {
                  <p-avatar [label]="client2LetterName(client.clt_full_name) | titlecase | shortName"
                    shape="circle" aria-label="client-search-initials" data-testid="client-search-initials" />
                }
                <div class="ml-2 min-w-0 flex-1">
                  <div class="flex align-items-center gap-2 mb-1">
                    <span class="font-semibold text-900 text-sm overflow-hidden text-overflow-ellipsis white-space-nowrap"
                      innerHTML="{{client.clt_full_name | highlight: selectedClient}}"
                      data-testid="client-search-name">
                    </span>
                    <div [innerHTML]="clientStatus(client)" data-testid="client-search-status"></div>
                  </div>
                  <div class="text-600 text-xs" data-testid="client-search-id">
                    {{'Shared.SEARCH.MINI-SEARCH.CLIENT_ID' | translate}} {{client.clt_id}}
                  </div>
                </div>
              </div>
              <!-- Right Section: Tenant Info -->
              @if (getTenant(client); as tenant) {
                <div class="flex align-items-center text-600 ml-4" data-testid="client-search-tenant">
                  <i class="fa fa-home text-600 text-xs mr-1"></i>
                  <span class="text-800 text-sm">{{tenant.name_primary_language}}</span>
                </div>
              }
            </div>
          </ng-template>
          <ng-template pTemplate="footer">
            <div class="p-2 cursor-pointer text-primary border-top-1 border-300 sticky bottom-0 surface-0 z-1 text-sm"
              (click)="loadMoreClients($event, pageNumber+10)" data-testid="load-more-clients" aria-label="Load more clients">
              <i class="fa fa-refresh mr-2"></i>
              {{'common.BUTTONS.BTN_LOAD_MORE' | translate}}
            </div>
            @if (showCreateClient()) {
              <div (click)="OpenPopup()" class="p-2 cursor-pointer text-primary border-top-1 border-300 sticky bottom-0 surface-0 z-1 text-sm" data-testid="create-new-client" aria-label="Create new client">
                <i class="fa fa-arrow-up-left"></i>
                {{ 'Shared.SEARCH.MINI-SEARCH.CREATENEWCLIENT' | translate }}
              </div>
            }
          </ng-template>
        </p-autoComplete>
      }
      @if (currentClientId && (selectedClient$ | async); as selectedClient) {
        <div class="surface-0 text-sm border-1 border-300 border-round p-2 flex align-items-center justify-content-between w-full"
          pStyleClass=".search-dropdown" enterFromClass="hidden" enterActiveClass="scalein" leaveToClass="hidden"
          leaveActiveClass="fadeout" [hideOnOutsideClick]="true" data-testid="selected-client-container">
          <div class="flex align-items-center -my-1 mr-3 cursor-pointer" (click)="navigateToClientProfile(selectedClient)">
            @if (selectedClient.clt_image) {
              <p-avatar image="{{selectedClient.clt_image}}" shape="circle" aria-label="selected-client-avatar" data-testid="selected-client-avatar" />
            }
            @if (!selectedClient.clt_image) {
              @if (!selectedClient.clt_image) {
                <p-avatar [label]="client2LetterName(selectedClient.clt_full_name) | titlecase | shortName"
                  shape="circle" aria-label="selected-client-initials" data-testid="selected-client-initials" />
              }
            }
            <span class="mx-2" 
              innerHTML="<strong class='text-primary'>{{selectedClient.clt_full_name}}</strong>"
              data-testid="selected-client-name" aria-label="Selected client name">
            </span>
            <span class="text-600 font-normal text-xs" data-testid="selected-client-id">
              <span class="hidden md:inline">CLIENT ID</span>
              {{selectedClient.clt_id}}
            </span>
          </div>
          <div class="flex align-items-center">
            <div [innerHTML]="clientStatus(selectedClient)" data-testid="selected-client-status"></div>
            @if (!isDisabled()) {
              <span class='fa fa-times text-xl text-600 ml-2 cursor-pointer' (click)='clearClient()' data-testid="clear-client-button" aria-label="Clear selected client"></span>
            }
          </div>
        </div>
      }
    </div>
  </div>
}


<p-dialog [visible]="showAllMembers" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'1025px': '100vw', '640px': '100vw'}" [style]="{width: '25vw'}"
  styleClass="no-header-modal no-overflow-content" aria-label="all-members-dialog" data-testid="all-members-dialog">
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div
      class="p-3 md:py-3 md:px-4 flex align-items-center justify-content-between relative border-bottom-1 border-300" data-testid="dialog-header">
      <h2 class="mb-0 text-sm" [innerHTML]="'Shared.SEARCH.MINI-SEARCH.LIST-OF-N-Member' | translate:paramNList">
      </h2>
      <i class="fa fa-times text-xl text-600 cursor-pointer" (click)="showAllMembers = false" data-testid="close-dialog-button" aria-label="Close dialog"></i>
    </div>
    <!-- Header -->

    <!-- Search -->
    <div
      class="py-2 md:py-3 md:px-4 px-2 flex align-items-center surface-50 relative border-bottom-1 border-300" data-testid="dialog-search-container">
      <div class="p-inputgroup inline-flex w-full mb-3 md:mb-0">
        <span class="p-inputgroup-addon h-full"><i class="fa fa-search text-500"></i></span>
        <input type="text" [(ngModel)]="searchText" class="text-sm" pInputText
          placeholder="{{ 'Shared.SEARCH.MINI-SEARCH.PLACEHOLDER-SEARCH-MEMBERS' | translate }}..."
          aria-label="Search members" data-testid="search-members-input"/>
        </div>
      </div>
      <!-- Search -->

      <!-- Content -->
      <div class="surface-50 text-sm py-2 border-bottom-1 border-300" data-testid="members-list-container">
        <p-scrollPanel styleClass="w-full h-25rem">
          @for (member of filteredClient; track member; let i = $index) {
            <div class="flex align-items-center my-2 px-4"
              [attr.data-testid]="'member-item-' + i">
              <span class="mr-3" [attr.data-index]="i">
                @if (member.image) {
                  <p-avatar image="{{member.image}}" shape="circle" [attr.aria-label]="'member-avatar-' + i" [attr.data-testid]="'member-avatar-' + i" />
                }
                @if (!member.image) {
                  <p-avatar [label]="client2LetterName(member.full_name) | titlecase | shortName"
                    shape="circle" [attr.aria-label]="'member-initials-' + i" [attr.data-testid]="'member-initials-' + i" />
                }
              </span>
              <strong class="text-primary" [attr.data-testid]="'member-name-' + i">
                {{member.full_name}}
              </strong>
            </div>
          }
        </p-scrollPanel>
      </div>
      <!-- Content -->
    </ng-template>
  </p-dialog>

  <!-- Models Prospect Start -->
  <!-- <create-prospect *ngIf="showCreateProspectPopup$ | async as showPopup" [visible]="showPopup" (onHide)="closeDialog()"  (onHide)="closeDialog()" 
  (hidePopup)="hidePopup($event)">
</create-prospect> -->
<!-- Models Prospect End -->


